import en from './en'

import cn from './zh'

export default {
    en: en,
    cn: cn
}